// Mock data for HennabyAnjali website
import bridalHenna from '../assets/henna/bridalhenna.jpg';
import eventsHenna from '../assets/henna/eventhenna.jpg';
import guestsHenna from '../assets/henna/guesthenna.jpg';
import extra from '../assets/henna/extra.jpg';
import nails from '../assets/nails/nails.jpg';
export const hennaServices = [
  {
    id: 1,
    title: 'Bridal Henna',
    description: 'Intricate and elaborate henna designs perfect for your special day. Our bridal packages include full hand and feet designs with traditional and contemporary patterns.',
    image:  bridalHenna,
    features: ['Full hand & feet coverage', 'Custom designs', 'Long-lasting stain', 'Premium quality henna']
  },
  {
    id: 2,
    title: 'Events Henna',
    description: 'Beautiful henna designs for festivals, parties, and celebrations. Quick, elegant patterns that add charm to any occasion.',
    image:  eventsHenna,
    features: ['Festival designs', 'Party-ready styles', 'Quick application', 'Group bookings available']
  },
  {
    id: 3,
    title: 'Guests Henna',
    description: 'Simple yet stunning henna designs perfect for guests at weddings and events. Elegant patterns that complement any outfit.',
    image:  guestsHenna,
    features: ['Simple & elegant', 'Quick designs', 'Affordable rates', 'Perfect for all ages']
  }
];

export const nailArtServices = [
  {
    id: 1,
    title: 'Acrylic Gel Nails',
    description: 'Professional acrylic gel nail extensions with stunning designs. Long-lasting, durable, and customizable to match your style.',
    image: 'https://images.pexels.com/photos/704815/pexels-photo-704815.jpeg',
    features: ['Custom designs', 'Long-lasting', 'Gel polish finish', 'Variety of shapes & lengths']
  },
  {
    id: 2,
    title: 'Press-on Nails',
    description: 'Ready-to-wear press-on nails with beautiful designs. Easy to apply, reusable, and perfect for those who want salon-quality nails at home.',
    image: 'https://images.pexels.com/photos/887352/pexels-photo-887352.jpeg',
    features: ['Reusable', 'Easy application', 'Custom designs available', 'Multiple size sets']
  }
];

export const galleryImages = [
  { id: 1, url: bridalHenna, category: 'henna', alt: 'Bridal henna design' },
  { id: 2, url: eventsHenna, category: 'henna', alt: 'Event henna design' },
  { id: 3, url: guestsHenna, category: 'henna', alt: 'Guest henna design' },
  { id: 10, url: extra, category: 'henna', alt: 'Guest henna design' },
  { id: 4, url: 'https://images.pexels.com/photos/35490980/pexels-photo-35490980.jpeg', category: 'henna', alt: 'Intricate henna pattern' },
  { id: 5, url: 'https://images.pexels.com/photos/704815/pexels-photo-704815.jpeg', category: 'nails', alt: 'Acrylic nail art' },
  { id: 6, url: 'https://images.pexels.com/photos/887352/pexels-photo-887352.jpeg', category: 'nails', alt: 'Press-on nail design' },
  { id: 7, url: 'https://images.pexels.com/photos/939836/pexels-photo-939836.jpeg', category: 'nails', alt: 'Press-on nail design' },
  { id: 8, url: 'https://images.pexels.com/photos/6135696/pexels-photo-6135696.jpeg', category: 'nails', alt: 'Acrylic gel nails' },
  { id: 9, url: nails, category: 'nails', alt: 'Press-on nail design' }

];

export const contactInfo = {
  phone: '+61 468 895 533',
  email: 'hennabyanjalii@gmail.com',
  whatsapp: '+61 468 895 533',
  instagram: '@henna_by.anjali',
  facebook: 'HennabyAnjali'
};